module.exports = __webpack_public_path__ + "fonts/ReadexPro-Light.a822bf9.ttf";